import MultiBaseSelect, {
  SelectOption,
} from 'components/inputs/MultiBaseSelect';
import React from 'react';
import { ActionMeta, ValueType } from 'react-select/src/types';

export interface MultiSelectOption {
  label: string;
  value: string;
}

interface Props {
  id: string;
  value?: MultiSelectOption[];
  options: MultiSelectOption[];
  onChange: (
    multiSelectOptions: ValueType<MultiSelectOption, boolean>,
    actionsMeta: ActionMeta<MultiSelectOption>
  ) => void;
  defaultValue?: ValueType<SelectOption, boolean>;
  placeholder?: string;
  inputId?: string;
}

class MultiSelect extends React.Component<Props> {
  render(): React.ReactNode {
    return <MultiBaseSelect {...this.props} isMulti />;
  }
}

export default MultiSelect;
